import { api } from "assets/scripts/utilities/api-clients";

export const count = async (options) => {
  const response = await api.get("/kam/accounts/count", options);

  return response;
};
